import React from 'react';
import AthleteList from './AthleteList';
import GroupsList from './GroupsList';
import ProgramsList from './ProgramsList';
import styles from './DashboardPage.module.css';

export default function DashboardPage() {
    return (
        <div className={styles.dashboardColumn}>
            <AthleteList />
            <GroupsList />
            <ProgramsList />
        </div>
    );
}
